<div class="flex flex-col w-full relative">
  <label *ngIf="label" class="text-[12px] font-medium text-corporate-3 mb-1 block">
    {{label}}<span *ngIf="required" class="text-error font-bold ml-0.5"> *</span>
  </label>

  <button
    type="button"
    (click)="toggleDropdown()"
    [disabled]="disabled"
    class="app-select-trigger flex items-center justify-between w-full px-2.5 py-1.5 text-[13px] bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none cursor-pointer disabled:bg-[#f4f6f9] disabled:opacity-70 disabled:cursor-not-allowed"
    [class.border-corporate]="isOpen"
  >
    <span class="truncate" [class.text-corporate-3]="innerValue" [class.text-[#8a94a0]]]="!innerValue">{{selectedLabel}}</span>
    <lucide-icon name="chevron-down" [size]="16" class="flex-shrink-0 transition-transform duration-200" [class.rotate-180]="isOpen"></lucide-icon>
  </button>

  <div
    *ngIf="isOpen"
    class="app-select-dropdown absolute top-full left-0 mt-1 bg-white border border-[#e8edf3] rounded-lg shadow-[0_12px_32px_rgba(40,56,66,0.22)] z-50 max-h-60 overflow-y-auto overflow-x-hidden py-1 min-w-full"
  >
    <ng-container *ngIf="!hasGroups">
      <div *ngIf="!options || options.length === 0" class="px-3 py-2 text-sm text-[#8a94a0] italic">
        Sin opciones
      </div>
      <div *ngIf="columns > 1 && options && options.length > 0" class="grid p-1 gap-0.5" [style.gridTemplateColumns]="'repeat(' + columns + ', 1fr)'">
        <div
          *ngFor="let option of options"
          (click)="selectOption(option)"
          class="px-2 py-1.5 text-[13px] text-center cursor-pointer rounded-md transition-colors duration-150"
          [class.bg-corporate]="option.value === innerValue"
          [class.text-white]="option.value === innerValue"
          [class.text-corporate-3]="option.value !== innerValue"
          [class.hover:bg-hover-2]="option.value !== innerValue"
        >
          {{option.label}}
        </div>
      </div>
      <ng-container *ngIf="columns <= 1">
        <div
          *ngFor="let option of options"
          (click)="selectOption(option)"
          class="px-3 py-2 text-sm cursor-pointer transition-colors duration-150"
          [class.bg-corporate]="option.value === innerValue"
          [class.text-white]="option.value === innerValue"
          [class.text-corporate-3]="option.value !== innerValue"
          [class.hover:bg-hover-2]="option.value !== innerValue"
        >
          {{option.label}}
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="hasGroups">
      <ng-container *ngFor="let group of optionGroups">
        <div class="px-3 py-1.5 text-[11px] font-bold text-[#8a94a0] uppercase tracking-wide">{{group.label}}</div>
        <div
          *ngFor="let option of group.items"
          (click)="selectOption(option)"
          class="px-3 py-2 text-sm cursor-pointer transition-colors duration-150"
          [class.bg-corporate]="option.value === innerValue"
          [class.text-white]="option.value === innerValue"
          [class.text-corporate-3]="option.value !== innerValue"
          [class.hover:bg-hover-2]="option.value !== innerValue"
        >
          {{option.label}}
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>